import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Modal, Paragraph, Popover, Spinner } from '@treams/treams-ui';

export default function EvaluationSubmissionSignatureModal(props: {
	submission: graphql.EvaluationSubmission;
	saving: boolean;
	onSign: () => void;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const handleSign = () => {
		props.onSign();
		props.onDismiss();
	};

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={t('evaluation.submission.confirm.modal.title')}
					onClose={props.onDismiss}
				/>
				<Modal.Contents>
					<Paragraph>{t('evaluation.submission.confirm.modal.description')}</Paragraph>
				</Modal.Contents>

				{props.saving ? (
					<Spinner centered />
				) : (
					<Modal.FormFooter
						onSave={handleSign}
						saveTitle={t('evaluation.submission.confirm.modal.confirm')}
						onCancel={props.onDismiss}
					/>
				)}
			</Modal>
		</Popover>
	);
}
